export const DEFAULT_WEBINAR_LINK = "https://www.klim.eco/de/landwirte/webinare";
export const SCHEDULE_CALL_LINK = "https://www.klim.eco/de/landwirte/kontakt";
